import { render } from "./BeforeLoginLayout.vue?vue&type=template&id=3c667f20&ts=true"
import script from "./BeforeLoginLayout.vue?vue&type=script&lang=ts"
export * from "./BeforeLoginLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__